import fontsStyles from '../../../styles/modules/fonts.module.scss';
import styles from './WChanceStaging.module.scss';

export interface WChanceStagingProps {
  size?: 'small' | 'default' | 'large' | 'xLarge';
}

function WChanceStaging({ size = 'default' }: WChanceStagingProps) {
  const componentStyles = styles;

  return (
    <div className={`${componentStyles.wchanceRank} ${componentStyles[`${size}RankImg`]}`}>
      <p className={`${componentStyles.wchanceRankText} ${componentStyles[`${size}RankText`]}`}>
        <span className={fontsStyles.montserrat}>W</span>
        <span className={`${componentStyles.overwrapText} ${componentStyles[`${size}OverwrapText`]}`}>チャンス</span>
      </p>
    </div>
  );
}

export default WChanceStaging;
